import * as React from 'react'

export enum ButtonStyle {
    Orange = "btn-tertiary"
}

interface IProps {
    label: string
    id?: string
    name?: string
    disabled?: boolean
    buttonStyle?: ButtonStyle
    onClick: () => void
}

export const Button = (props: IProps) => (
    <button
        id={props.id}
        name={props.name}
        disabled={props.disabled}
        className={props.buttonStyle}
        onClick={props.onClick}>

        {props.label}
    </button>
)